import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import type Employee from 'modules/employees/store/models/Employee'

const NewDocumentPage = () => {
  const { navigation } = useNavigation()
  const { employee, folder, initialFolder } = useOutletContext<{
    employee: Employee
    folder: Folder
    initialFolder: Folder
  }>()

  return (
    <NewDocument
      employee={employee}
      folder={initialFolder ?? folder}
      backRoute={navigation.documents.list.fullPath()}
    />
  )
}

export default NewDocumentPage
